<template>
  <div class="pa-4">
    <navigation-drawer></navigation-drawer>
    <router-view />
  </div>
</template>

<script>
import navigationDrawer from "../components/layouts/navigationDrawer.vue";
export default {
  components: {
    navigationDrawer,
  },
  // Your component options here
};
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
  // overflow: hidden;
}
.v-main__wrap {
  // overflow: hidden;
}
</style>
